define('views/ecards/pass_info',[
    'backbone',
    'views/_base/baseview',
    'text!views/ecards/pass_info.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className : 'pass-info-container',
        tagName   : 'div',
        isRender  : true,
        needsAuth : false,
        template  : _.template(Template),
        events    : {
            // 'click .js-pass-info-button': 'closeMODAL',
            'click #pf-modal-close-btn'   : 'closeMODAL'
        },
        initialize: function(options){
            var options = options || {};

            this.pass = options.pass;
            
            this.elementName = options.elementName;
            
            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            this.renderPassInfo();

            setTimeout(function(){
                // $('.js-pass-info-button').on('click', that.closeMODAL);
                $('#pf-modal-close-btn').on('click', that.closeMODAL);
            });

            return this;
        },

        renderPassInfo: function(){
            var that = this;

            this.pass.info.forEach(function(content){
                var html = [
                    '<li>',
                        '<h3 style="color: ' + that.pass.label_color + ';">' + content.label + '</h3>',
                        '<p style="color: ' + that.pass.label_color + ';">' + content.value + '</p>',
                    '</li>'
                ].join('');
                that.$el.find('.js-pass-info-content').append(html);
            });

        },

        closeMODAL: function(){
            $('#pf-modal-modern').fadeOut(function(){
                $('#pf-modal-modern').remove();
            });
        },

        close: function(){}
    });
});

